import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propShape, } from '../../../../../helpers/custom-prop-types';
import FormChangeAcceptance from '../Form/FormChangeAcceptance';
const ChangeAcceptance = ({ disabled, onChange, solution }) => (_jsx("div", Object.assign({ className: `overview-terms ${disabled ? 'is-disabled' : ''}` }, { children: _jsxs("dl", { children: [_jsx("dt", { children: "\u958B\u59CB\u53EF\u80FD\u6642\u671F" }), _jsx("dd", Object.assign({ className: 'input-form-select small is-gray' }, { children: _jsx(FormChangeAcceptance, { disabled: disabled, form: `FormChangeAcceptance#${solution.id}`, handleSubmit: onChange, initialValues: { acceptance: solution.acceptance } }) }))] }) })));
ChangeAcceptance.propTypes = {
    disabled: propBool().isRequired,
    onChange: propFunc().isRequired,
    solution: propShape().isRequired,
};
export default ChangeAcceptance;
